/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  borderless: Boolean,
  defaultExpandAll: Boolean,
  disabled: Boolean,
  expandIcon: {
    type: [Boolean, Function],
    "default": true
  },
  expandIconPlacement: {
    type: String,
    "default": "left",
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "right"].includes(val);
    }
  },
  expandMutex: Boolean,
  expandOnRowClick: {
    type: Boolean,
    "default": true
  },
  value: {
    type: Array,
    "default": void 0
  },
  defaultValue: {
    type: Array
  },
  onChange: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
